import { ApolloLink } from '@apollo/client';
import UploadHttpLink from 'apollo-upload-client/UploadHttpLink.mjs';

import { APIType, getGraphURL } from 'utils/apiUtils';

import { operationTypeFetch } from './graphqlOperationTypeLink';
import { createBigDecimalResponseFetch } from './scalar/scalarLink';

const uploadOptions: ConstructorParameters<typeof UploadHttpLink>[0] = {
  uri: getGraphURL(APIType.GRAPHQL),
  // Workaround to force Content-Type on every upload request
  formDataAppendFile: (formData: FormData, fieldName, file) => {
    const operations = formData.get('operations');
    // Only set if the `operations` value is a regular string which means it has not yet been set
    if (typeof operations === 'string') {
      formData.set(
        'operations',
        Object.assign(
          new Blob([operations], {
            type: 'application/json; charset=utf-8',
          })
        )
      );
      formData.set(
        'map',
        /* eslint-disable @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions */
        new Blob([String(formData.get('map'))], {
          type: 'application/json; charset=utf-8',
        })
        /* eslint-enable @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions */
      );
    }

    formData.append(fieldName, file.blob || file);
  },
};

/**
 * Terminating link (last link in composed network link)
 * requesting graphql results from our server.
 */
export const uploadLink = new ApolloLink((operation, forward) =>
  new UploadHttpLink({
    ...uploadOptions,
    fetch: createBigDecimalResponseFetch({ fetch: operationTypeFetch, operation }),
  }).request(operation, forward)
);
